import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import Layout from '@/components/layout/LayoutIndex.vue'
import LayoutHome from '@/components/layout/LayoutHome.vue'

// 1. 首页相关路由

// 2. 项目相关路由
export const asyncProjectRoutes: Array<RouteRecordRaw> = [
  {
    path: '/project',
    name: 'ProjectPage',
    component: Layout,
    redirect: '/project/index',
    meta: { title: '项目管理', icon: 'data-menu' },
    children: [
      {
        path: '/project/index',
        name: 'ProjectIndex',
        component: () => import('@/views/projects/ProjectIndex.vue'),
        meta: { title: '项目视图' }
      },
      {
        path: '/project/add',
        name: 'ProjectAdd',
        component: () => import('@/views/projects/ProjectAdd.vue'),
        meta: { title: '添加项目' }
      },
      {
        path: '/project/detail/:id',
        name: 'ProjectDetail',
        component: () => import('@/views/projects/ProjectDetail.vue'),
        meta: { title: '项目详情' }
      },
      {
        path: '/project/types',
        name: 'ProjectType',
        component: () => import('@/views/projects/types/ProjectType.vue'),
        meta: { title: '项目类型' }
      },
      {
        path: '/cooperators',
        name: 'CooperativeUnits',
        component: () => import('@/views/projects/cooperation/CooperativeUnits.vue'),
        meta: { title: '合作单位' }
      }
    ]
  }
]

// 3. 调查记录相关路由
export const asyncSurveyRoutes: Array<RouteRecordRaw> = [
  {
    path: '/survey',
    name: 'SurveyPage',
    component: Layout,
    redirect: '/survey/index',
    meta: { title: '调查视图', icon: 'data-menu' },
    children: [
      {
        path: '/survey/index',
        name: 'SurveyIndex',
        component: () => import('@/views/survey/SurveyIndex.vue'),
        meta: { title: '调查管理' }
      },
      {
        path: '/survey/detail',
        name: 'SurveyDetail',
        component: () => import('@/views/survey/SurveyDetail.vue'),
        meta: { title: '调查详情' }
      },
      {
        path: '/survey/add',
        name: 'SurveyAdd',
        component: () => import('@/views/survey/SurveyAdd.vue'),
        meta: { title: '添加调查' }
      },
      {
        path: '/survey/edit',
        name: 'SurveyEdit',
        component: () => import('@/views/survey/SurveyEdit.vue'),
        meta: { title: '编辑调查' }
      },
      {
        path: '/survey/add-photos',
        name: 'SurveyAddPhotos',
        component: () => import('@/views/survey/SurveyAddPhotos.vue'),
        meta: { title: '管理照片' }
      },
      {
        path: '/review/index',
        name: 'ReviewIndex',
        component: () => import('@/views/survey/reviews/ReviewIndex.vue'),
        meta: { title: '评级管理' }
      },
      {
        path: '/place/index',
        name: 'PlaceIndex',
        component: () => import('@/views/survey/place/PlaceIndex.vue'),
        meta: { title: '点位管理' }
      },

      {
        path: '/picture/index',
        name: 'PictureIndex',
        component: () => import('@/views/survey/pictures/PictureIndex.vue'),
        meta: { title: '照片管理' }
      }
    ]
  }
]

// 4. 分类相关路由
export const asyncCategoryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/category',
    name: 'CategoryPage',
    component: Layout,
    redirect: '/category/index',
    meta: { title: '分类视图', icon: 'data-menu' },
    children: [
      {
        path: '/category/index',
        name: 'CategoryIndex',
        component: () => import('@/views/categories/CategoryIndex.vue'),
        meta: { title: '分类管理' }
      },

      {
        path: '/landscape',
        name: 'LandscapeType',
        component: () => import('@/views/categories/landscape/LandscapeType.vue'),
        meta: { title: '景观类型' }
      }
    ]
  }
]

// 5. 用户相关路由
export const asyncUserRoutes: Array<RouteRecordRaw> = [
  {
    path: '/user',
    name: 'UserPage',
    component: Layout,
    redirect: '/user/index',
    meta: { title: '用户管理', icon: 'data-menu' },
    children: [
      {
        path: '/user/index',
        name: 'UserIndex',
        component: () => import('@/views/users/UserIndex.vue'),
        meta: { title: '用户视图' }
      },
      {
        path: '/user/detail/:id',
        name: 'UserDetail',
        component: () => import('@/views/users/UserDetail.vue'),
        meta: { title: '用户详情' }
      }
    ]
  }
]

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'IntroPage',
    redirect: '/intro',
    children: [
      {
        path: '/intro',
        name: 'Introduction',
        component: () => import('@/views/intro/IntroIndex.vue'),
        meta: { title: '介绍' }
      }
    ]
  },

  
  {
    path: '/home',
    name: 'HomeIndex',
    component: LayoutHome,
    meta: { title: '首页', isGroupName: true, icon: 'subscription' },
    children: [
      {
        path: '/home',
        name: 'HomeIndex',
        component: () => import('@/views/home/HomeIndex.vue'),
        meta: { title: '首页' }
      },
      
      {
        path: '/home/multi',
        name: 'HomeMultiIconsLayer',
        component: () => import('@/views/home/HomeMultiIconsLayer.vue'),
        meta: { title: '地图效果展示' }
      },
      {
        path: '/home/satellite',
        name: 'HomeSatelliteLayer',
        component: () => import('@/views/home/HomeSatellite.vue'),
        meta: { title: '卫星图效果展示' }
      }
    ]
  },
  {
    path: '/map',
    name: 'MapIndex',
    component: LayoutHome,
    meta: { title: '地图', isGroupName: true, icon: 'subscription' },
    children: [
      {
        path: '/map',
        name: 'MapIndex',
        component: () => import('@/views/home/HomeOneIconLayer.vue'),
        meta: { title: '树种分布地图' }
      }
    ]
  },
 
  

  ...asyncUserRoutes,
  ...asyncProjectRoutes,
  ...asyncCategoryRoutes,
  ...asyncSurveyRoutes,
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/LoginIndex.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/iconpark-test',
    name: 'IconParkTest',
    component: () => import('@/views/IconParkTest.vue'),
    meta: { title: 'IconPark测试' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes: routes,
  // 添加严格模式，防止尾部斜杠问题
  strict: true,
  // 确保路由匹配时去除尾部斜杠
  sensitive: false
})

// 添加路由守卫处理尾部斜杠问题
router.beforeEach((to, _from, next) => {
  // 如果路径以斜杠结尾且不是根路径，重定向到不带斜杠的版本
  if (to.path !== '/' && to.path.endsWith('/')) {
    const pathWithoutSlash = to.path.slice(0, -1)
    next({ path: pathWithoutSlash, query: to.query, hash: to.hash })
  } else {
    next()
  }
})

export default router
